import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    WubrowserURL: "https://biobigdata.nju.edu.cn/wubrowser/",
    JbrowserURL: "https://biobigdata.nju.edu.cn/jbrowse2/",
    blastSequence: '',
    blastSeqType: '',
    genomeBlast: '',
    fromGenome: false,
    fromSeaching: false
  },
  getters: {
  },
  mutations: {
    updateJbURL(state, newURL) {
      state.JbrowserURL = newURL
    },
    updateWbURL(state, newURL) {
      state.WubrowserURL = newURL
    },
    updateBlastSeq(state, seq) {
      state.blastSequence = seq
    },
    updateBlastSeqType(state, type) {
      state.blastSeqType = type
    },
    updateGenomeBlast(state, genome) {
      state.genomeBlast = genome
    },
    updateFromGenome(state, flag) {
      state.fromGenome = flag
    },
    changeFromSeaching(state, flag) {
      state.fromSeaching = flag
    }
  },
  actions: {
  },
  modules: {
  }
})
